import { CertificationsExpirationOptions } from 'containers/certification-status-report/CertificationStatusReportFilter/CertificationStatusReportFilter';
import { CertificationStatusReportTabType } from 'containers/certification-status-report/CertificationStatusReportTabHeader/CertificationStatusReportTabHeader';
import useNavigation from './useNavigation';

interface IParams {
  certification_expiration_date?: CertificationsExpirationOptions;
  certification_report_type?: CertificationStatusReportTabType;
  employee_id?: string;
}

export default function useCertificationsReportNavigation() {
  return useNavigation<IParams>('/certification-status-report');
}
